import { render, staticRenderFns } from "./aModal.vue?vue&type=template&id=58928602&scoped=true&"
import script from "./aModal.vue?vue&type=script&lang=js&"
export * from "./aModal.vue?vue&type=script&lang=js&"
import style0 from "./aModal.vue?vue&type=style&index=0&id=58928602&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58928602",
  null
  
)

export default component.exports